import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "trigger", "chevron"]
  static values = { selectionRequired: { type: Boolean, default: false } }

  connect() {
    this.handleClickOutside = this.handleClickOutside.bind(this)
    document.addEventListener("click", this.handleClickOutside)

    if (this.selectionRequiredValue) {
      this.handleSelectionChange = this.handleSelectionChange.bind(this)
      document.addEventListener("tableSelection:change", this.handleSelectionChange)
    }
  }

  disconnect() {
    document.removeEventListener("click", this.handleClickOutside)

    if (this.selectionRequiredValue) {
      document.removeEventListener("tableSelection:change", this.handleSelectionChange)
    }
  }

  toggle(event) {
    event.stopPropagation()

    if (this.hasTriggerTarget && this.triggerTarget.classList.contains("disabled")) {
      return
    }

    this.menuTarget.classList.toggle("hidden")
    this.rotateChevron()
  }

  close() {
    this.menuTarget.classList.add("hidden")
    this.rotateChevron()
  }

  handleClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  handleSelectionChange(event) {
    if (!this.hasTriggerTarget) return

    const hasSelection = event.detail.selectedIds.length > 0
    this.triggerTarget.classList.toggle("disabled", !hasSelection)

    if (!hasSelection) {
      this.close()
    }
  }

  rotateChevron() {
    if (!this.hasChevronTarget) return

    const isOpen = !this.menuTarget.classList.contains("hidden")
    this.chevronTarget.classList.toggle("rotate-180", isOpen)
  }
}
